import React, { useState } from 'react';
import { CheckCircle2, ShieldCheck, Lock, Clock, Zap } from 'lucide-react';
const PAYMENT_URL = 'https://pagos.digipromarket.com/cart/56229348835654:1';
const PAYMENT_URL_UPSELL = 'https://pagos.digipromarket.com/cart/56229516345670:1';
export function HeroSection() {
  const [hasUpsell, setHasUpsell] = useState(false);
  return <section className="bg-navy pt-12 pb-24 px-4 relative overflow-hidden" data-id="element-102">
      <div className="absolute top-10 left-10 w-64 h-64 bg-teal/20 rounded-full blur-3xl" data-id="element-103" />
      <div className="absolute bottom-10 right-10 w-80 h-80 bg-gold/10 rounded-full blur-3xl" data-id="element-104" />

      <div className="max-w-4xl mx-auto text-center relative z-10" data-id="element-105">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-heading font-900 text-white leading-[1.1] mb-6 drop-shadow-lg" data-id="element-106">
          Adelgaza Con Tu Airfryer En 10 Minutos Al Día
        </h1>

        <p className="text-2xl md:text-3xl font-heading font-bold text-gold mb-4 max-w-3xl mx-auto leading-snug" data-id="element-107">
          Sin Dietas, Sin Pasar Hambre y Sin Recetas Complicadas
        </p>

        <p className="text-lg md:text-xl font-semibold text-white/80 mb-4 max-w-3xl mx-auto leading-relaxed" data-id="element-108">
          El sistema 10-3-1 que ya usan más de 1.200 mujeres en España para
          perder entre 3 y 6kg el primer mes cocinando proteína, vegetales y
          repostería fit — todo en una sola máquina
        </p>

        <p className="text-sm md:text-base text-white/60 italic mb-12" data-id="element-109">
          Creado por la Dra. Elena Martínez Solís — Nutricionista Clínica Col.
          Nº AND-4821
        </p>

        {/* Product Mockup */}
        <div className="relative max-w-3xl mx-auto mb-12" data-id="element-110">
          <img src="https://cdn.magicpatterns.com/uploads/ge6ddC3LbijriWmfqvSKgP/EL_ACELERADOR_24H.jpg" alt="El Acelerador 24H — Pack Completo: 5 Tomos + 3 Bonos" className="w-full h-auto rounded-2xl shadow-2xl" style={{
          aspectRatio: '848/1264'
        }} width={848} height={1264} fetchPriority="high" decoding="async" data-id="element-111" />

          <div className="absolute -top-4 -right-4 md:-top-6 md:-right-6 bg-gold text-navy font-bold w-20 h-20 md:w-24 md:h-24 rounded-full flex items-center justify-center rotate-12 shadow-xl border-4 border-white animate-float" data-id="element-112">
            <div className="text-center leading-tight" data-id="element-113">
              <span className="block text-xs md:text-sm" data-id="element-114">SOLO</span>
              <span className="block text-xl md:text-2xl font-heading" data-id="element-115">
                19€
              </span>
            </div>
          </div>
        </div>

        <div className="max-w-xl mx-auto" data-id="element-116">
          {/* Upsell Bump */}
          <div onClick={() => setHasUpsell(!hasUpsell)} className={`
              cursor-pointer rounded-2xl border-2 border-dashed p-4 mb-5 transition-colors duration-300 text-left min-h-[88px]
              ${hasUpsell ? 'border-gold bg-white/10' : 'border-white/20 bg-white/5 hover:bg-white/10'}
            `} data-id="element-117">
            <div className="flex items-start gap-3" data-id="element-118">
              <div className={`
                  w-6 h-6 rounded-md border-2 flex items-center justify-center flex-shrink-0 mt-0.5 transition-colors
                  ${hasUpsell ? 'bg-gold border-gold text-navy' : 'border-white/40 bg-transparent'}
                `} data-id="element-119">
                {hasUpsell && <CheckCircle2 className="w-4 h-4" data-id="element-120" />}
              </div>
              <div className="flex-1" data-id="element-121">
                <div className="flex items-center gap-2 mb-1" data-id="element-122">
                  <Zap className="w-4 h-4 text-gold" data-id="element-123" />
                  <span className="font-bold text-white text-sm" data-id="element-124">
                    ⚡ AÑADIR: Kit Acelerador "Vientre Plano" (+5€)
                  </span>
                </div>
                <p className="text-xs text-white/50" data-id="element-125">
                  Protocolo 21 Días + 7 Bebidas Metabólicas + Auditoría
                  anti-estancamiento
                </p>
              </div>
            </div>
          </div>

          {/* Payment Button */}
          <a href={hasUpsell ? PAYMENT_URL_UPSELL : PAYMENT_URL} className="block w-full" data-id="element-126">
            <div className="w-full bg-gold hover:bg-goldDark text-white font-bold text-center px-8 py-5 rounded-2xl shadow-2xl transition-all duration-300 animate-cta-pulse border-4 border-gold/30 hover:border-goldDark/30" data-id="element-127">
              <span className="text-2xl md:text-3xl block mb-1 drop-shadow-sm" data-id="element-128">
                🔥{' '}
                {hasUpsell ? 'QUIERO EL PACK + KIT POR 24,99€' : 'QUIERO EL PACK COMPLETO POR 19,99€'}
              </span>
              <span className="text-sm md:text-base font-medium opacity-90" data-id="element-129">
                {hasUpsell ? '(Ahorro 35€ hoy — Oferta expira pronto)' : '(Ahorro 30€ hoy — Oferta expira pronto)'}
              </span>
            </div>
          </a>

          <div className="mt-6 flex flex-wrap justify-center gap-x-6 gap-y-2 text-sm text-white/70 font-medium" data-id="element-130">
            <div className="flex items-center gap-1.5" data-id="element-131">
              <Clock className="w-4 h-4 text-gold/70" data-id="element-132" />
              <span data-id="element-133">Acceso inmediato</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-134">
              <ShieldCheck className="w-4 h-4 text-gold/70" data-id="element-135" />
              <span data-id="element-136">7 días de garantía</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-137">
              <Lock className="w-4 h-4 text-gold/70" data-id="element-138" />
              <span data-id="element-139">Pago 100% seguro</span>
            </div>
            <div className="flex items-center gap-1.5" data-id="element-140">
              <CheckCircle2 className="w-4 h-4 text-gold/70" data-id="element-141" />
              <span data-id="element-142">Sin suscripciones</span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}